<template>
  <div class="flex choosebar">
    <div :class="['select', selectitem ? 'active': '']">
      <p class="item" @click="showSelectOption">{{ title }}</p>
      <div class="select-option">
        <slot name="content"></slot>
        <slot name="btn">
          <div class="btn-wrap van-hairline--top">
            <span @click="reset">重置</span>
            <span @click="confirm">确定</span>
          </div>
        </slot>
      </div>
    </div>
    <div class="van-modal" :class="{ 'showmodal': showModal }" style="z-index: 2015;" @click="clickModal"></div>
  </div>
</template>
<script>
export default {
  name: 'ChooseLayer',
  props: {
    title: String
  },
  data() {
    return {
      checked: false,
      selectitem: false,
      showModal: false
    }
  },
  methods: {
    clickModal() {
      this.selectitem = false
      this.showModal = false
    },
    showSelectOption() {
      this.selectitem = !this.selectitem
      this.showModal = !this.showModal
    },
    confirm() {
      this.clickModal()
      this.$emit('confirm')
    },
    reset() {
      this.$emit('reset')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~style/var.less';
@import '~style/mixin.less';
.van-modal {
  display: none;
  top: 83px;
  &.showmodal {
    transition: 0.3;
    display: block;
  }
}

.choosebar {
  padding: 0 15px;
  // background-color: #eee;
}

.select {
  position: relative;
  text-align: center;
  width: 60px;
  .item {
    padding: 10px 0;
    font-size: 12px;
    color: #999;
  }
  &:after {
    transition: 0.3s;
    content: ' ';
    .setArrow(down, 6px, #ddd, 2px);
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
  }
  &.active {
    &:after {
      transform: rotate(-45deg);
    }
    .select-option {
      padding-bottom: 54px;
      padding-top: 10px;
      height: auto;
    }
  }
  + .select {
    margin-left: 6px;
    &:before {
      .setLeftLine();
    }
  }
  .select-option {
    position: fixed;
    top: 83px;
    left: 0;
    right: 0;
    z-index: 99999;
    height: 0;
    overflow: hidden;
    background: #fff;
    font-size: 14px;
    transition: 0.3s;
    .btn-wrap {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      span {
        line-height: 44px;
        text-align: center;
        flex: 1;
        + span {
          background-color: @c;
          color: #fff;
        }
      }
    }
  }
}

.van-picker {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseLayer.vue